import { DateTime } from 'luxon'

export const getTime = (
	parse?: string | null,
	year?: number,
	month?: number,
	day?: number,
	hour?: number
) => {
	const timezone = JSON.parse(localStorage.getItem('userProfile') || '')
		.timezone
	if (month === 0 && year) {
		month = 12
		year = year - 1
	}
	if (month === 13 && year) {
		month = 1
		year = year + 1
	}
	let date =
		year || month || day || hour
			? DateTime.local(year, month, day, hour)
			: DateTime.local()
	if (parse) {
		date = DateTime.fromISO(parse)
	}
	if (timezone) {
		date.setZone(timezone)
	} else {
		date.setZone('Europe/Kiev')
	}
	return date
}
